import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-notification',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './notification.component.html',
    styleUrl: './notification.component.scss'
})
export class NotificationComponent {
    @Input() text = '';
    @Input() severity = '';
    @Input() canClose = false;

    @Output()
    readonly closeClicked = new EventEmitter<void>();
}
